<div fxLayout="column" fxFill>
  <mat-toolbar class="header-tours">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span fxFlex="33.3%">{{ 'tours.tourOverview' | translate }}</span>
      <div fxFlex="33.3%" fxLayoutAlign="center">
        <button mat-button (click)="viewPreviousDay()">
          <mat-icon class="material-icons">keyboard_arrow_left</mat-icon>
        </button>
        <span class="current-date">{{ currentDate$ | async | date : 'dd.MM.yyyy' }}</span>
        <button mat-button (click)="viewNextDay()">
          <mat-icon class="material-icons">keyboard_arrow_right</mat-icon>
        </button>
      </div>
      <div fxFlex="33.3%" fxLayoutGap="1rem" fxLayoutAlign="end">
        <a mat-raised-button
          *ngxPermissionsOnly="['ROLE_USER']"
          color="primary"
          [routerLink]="['./new']"
          [queryParams]="{startDate: currentDate$ | async | date : 'yyyy-MM-ddT12:00:00.00Z'}"
          >
          <mat-icon class="material-icons">add</mat-icon>
          {{ 'tours.actions.create' | translate }}
        </a>
        <a mat-raised-button
          *ngxPermissionsOnly="['ROLE_USER']"
          color="primary"
          [routerLink]="['/appointments/new']"
          [queryParams]="{date: currentDate$ | async | date : 'yyyy-MM-dd'}"
          >
          <mat-icon class="material-icons">add</mat-icon>
          {{ 'appointment.actions.create' | translate }}
        </a>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container autosize>
    <mat-sidenav mode="side" disableClose="true" [opened]="isSidebarExpanded$ | async">
      <div class="content-mat-sidenav-left">
        <div class="mat-sidenav-navigation">
          <button class="toggle-sidebar-btn" mat-button (click)="toggleSidebar()">
            <mat-icon class="material-icons calendar" color="primary">insert_invitation</mat-icon>
            <mat-icon class="material-icons arrow">keyboard_arrow_left</mat-icon>
            <mat-icon class="material-icons arrow last">keyboard_arrow_left</mat-icon>
          </button>
        </div>
        <app-calendar></app-calendar>
        <app-absences-info></app-absences-info>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      @if (!(isSidebarExpanded$ | async)) {
        <button class="toggle-sidebar-btn" mat-button (click)="toggleSidebar()">
          <mat-icon class="material-icons calendar" color="primary">insert_invitation</mat-icon>
          <mat-icon class="material-icons arrow">keyboard_arrow_right</mat-icon>
          <mat-icon class="material-icons arrow last">keyboard_arrow_right</mat-icon>
        </button>
      }

      <div fxLayout="column" fxFill>
        <as-split unit="percent" [direction]="'vertical'" (dragEnd)="dragEnd($event.sizes)">
          <as-split-area [size]="sizes.defaultTourList" minSize="20">
            <mat-card appearance="outlined" [ngClass]="(isSidebarExpanded$ | async) ? '' : 'expanded'" fxFlex="grow" fxLayout="column">
              <mat-tab-group (selectedIndexChange)="tabSelectionChanged($event)" animationDuration="0ms" [selectedIndex]="currentTab$ | async">
                <mat-tab [label]="'tours.kinds.all' | translate"></mat-tab>
                <mat-tab [label]="'tours.kinds.deliveries' | translate"></mat-tab>
                <mat-tab [label]="'tours.kinds.maintenance' | translate"></mat-tab>
                <mat-tab [label]="'tours.kinds.service' | translate"></mat-tab>
                <mat-tab [label]="'appointment.appointments' | translate">
                  <app-appointment-list></app-appointment-list>
                </mat-tab>
              </mat-tab-group>
              @if ((currentView$ | async) === tourView.Tours) {
                <app-tour-list fxFlex="grow" [tours]="tours$ | async"></app-tour-list>
              }
            </mat-card>
          </as-split-area>
          <as-split-area [size]="sizes.returnTourList" minSize="20">
            <mat-card appearance="outlined" fxLayout="column" fxFlex="grow">
              <mat-card-header>{{ 'tours.kinds.return' | translate }}</mat-card-header>
              <app-tour-list fxFlex="grow" [tours]="returns$ | async" mode="returnList"></app-tour-list>
            </mat-card>
          </as-split-area>
        </as-split>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  @if (isActionPending$ | async) {
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
